import type { ActivityType } from '@/shared/api/experience';
import type { ComputedRef } from 'vue';

export enum ToursActivitiesCategory {
  ACTIVE = 'active',
  EDUCATIONAL = 'educational',
  CALM = 'calm',
  NATURE = 'nature',
}

export type ToursActivity = ActivityType & {
  category: ToursActivitiesCategory;
  categoryTitle: string;
};

export type ComputedToursActivitiesData = {
  toursActivities: ComputedRef<ToursActivity[]>;
};

export type Chip = {
  label: string;
  value: string;
  id?: number | string;
};

export type GroupIn = {
  title: string | null;
  tags: Chip[];
};
